import React, { useState, useEffect } from 'react'
// import "../../../node_modules/react-progress-button/react-progress-button.css"
import { useSnackbar } from 'react-simple-snackbar'
import { useLocation, useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { initialStateInventory } from '../../initialState'
import { getInventory } from '../../actions/inventoryAction'
import Button from '@material-ui/core/Button';
import { toCommas } from '../../utils/utils'
import styles from './inventoryDetails.module.css'
import moment from 'moment'
import { useHistory } from 'react-router-dom'
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import InputBase from '@material-ui/core/InputBase';
import { Container, Grid } from '@material-ui/core';
import Divider from '@material-ui/core/Divider';
import BorderColorIcon from '@material-ui/icons/BorderColor';
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn';
import Spinner from '../Spinner/Spinner'
import axios from 'axios';
import { Backup } from '@material-ui/icons'


const InventoryDetails = () => {

    const location = useLocation()
    const [inventoryData, setInventoryData] = useState(initialStateInventory)
    const [selectedDate, setSelectedDate] = useState(new Date());
    const [vendor, setVendor] = useState(null)
    const { id } = useParams()
    const { inventory } = useSelector((state) => state.inventories)
    const dispatch = useDispatch()
    const history = useHistory()
    // eslint-disable-next-line
    const [openSnackbar, closeSnackbar] = useSnackbar()
    const user = JSON.parse(localStorage.getItem('profile'))
    
    const useStyles = makeStyles((theme) => ({
        root: {
          display: 'flex',
          '& > *': {
            margin: theme.spacing(1),
          },
        },
        large: {
          width: theme.spacing(12),
          height: theme.spacing(12),
        },
        table: {
            minWidth: 650,
          },
    
        headerContainer: {
            // display: 'flex'
            paddingTop: theme.spacing(1),
            paddingLeft: theme.spacing(5),
            paddingRight: theme.spacing(1),
            backgroundColor: '#f2f2f2',
            borderRadius: '10px 10px 0px 0px'
        }
      }));
    

    const classes = useStyles()

    useEffect(() => {
        dispatch(getInventory(id));
      },[id, dispatch, location]);

      useEffect(() => {
        if(inventory) {
            //Automatically set the default inventory values as the ones in the inventory to be updated
            setInventoryData(inventory)
            setVendor(inventory.vendor[0])
            setSelectedDate(inventory.inventoryDate)
           
        }
    }, [inventory])

  
   
  const editInventory = (id) => {
    history.push(`/edit/inventory/${id}`)
  }

  


const iconSize = {height: '18px', width: '18px', marginRight: '10px', color: 'gray'}
const [open, setOpen ] = useState(false)



if(!inventory) {
  return (
    <Spinner />
  )
}


return (

  <div className={styles.PageLayout}>
    
    <Container style={{width: '85%', paddingTop: '70px', paddingBottom: '50px', border: 'none'}} >
              
              <Grid container justifyContent="space-between" >
                  <Grid item>
                      {/* <Avatar alt="Logo" variant='square' src="" className={classes.large} /> */}
                  </Grid>
                  <Grid item>
                      
                      Inventory #:
                      <div style={{
                          marginTop: '15px',
                          width: '100px',
                          padding: '8px',
                          display: 'inline-block',
                          backgroundColor: '#f4f4f4',
                          outline: '0px solid transparent'
                      }} 
                          contenteditable="true"
                          onInput={e => setInventoryData({
                          ...inventoryData, inventoryNumber: e.currentTarget.textContent})
                          }
                      >
                      <span style={{width:'40px',
                          color: 'black',
                          padding: '15px',
                      }} 
                          contenteditable="false"> {inventoryData?.inventoryNumber}</span>
                      <br/>
                      </div>
                  </Grid>
              </Grid >
          
          <Divider />
       
              <Grid container justifyContent="space-between" style={{marginTop: '40px'}} >
                  <Grid item style={{width: '50%'}}>
                      <Container>
                          <Typography variant="overline" style={{color: 'gray', paddingRight: '3px'}} gutterBottom>Buy from</Typography>
                          

                          {vendor  && (
                              <>
                                  <Typography variant="subtitle2" gutterBottom>{vendor.name}</Typography>
                                  <Typography variant="body2" >{vendor.email}</Typography>
                                  <Typography variant="body2" >{vendor.phone}</Typography>
                                  <Typography variant="body2">{vendor.address}</Typography>
                                 
                              </>
                          )}
                          
                         
                         
                      </Container>
                  </Grid>

                  <Grid item style={{marginRight: 20, textAlign: 'right'}}>
                       <Typography variant="overline" style={{color: 'gray'}} gutterBottom>Date</Typography>
                       <Typography variant="body2" gutterBottom>{moment(inventory.inventoryData).format("MMM Do YYYY")}</Typography>
                       <Typography variant="overline" style={{color: 'gray'}} gutterBottom>Total Weight</Typography>
                       <Typography variant="body2" gutterBottom>{inventory.totalWeight}</Typography>

                  </Grid>
              </Grid>
        

    </Container>
    <Container style={{width: '85%', paddingTop: '30px', paddingBottom: '50px', border: 'none'}} >

      <TableContainer component={Paper} className="tb-container" >
      <Table className={classes.table} aria-label="simple table" >
          <TableHead>
          <TableRow>
              <TableCell>Item</TableCell>
              <TableCell>Weight</TableCell>
          </TableRow>
          </TableHead>
          <TableBody>
          {inventoryData.items.map((itemField, index) => (
              <TableRow key={index}>
              <TableCell  scope="row" style={{width: '80%' }}> 
                { itemField.metal.metalName}
              </TableCell>
              <TableCell > 
              
              <InputBase type="number" name="weight"               
              disabled
              value={itemField.weight} placeholder="0" /> 

              </TableCell>             
              
              </TableRow>
          ))}
          </TableBody>
      </Table>
      </TableContainer>

       {/* <button className={styles.submitButton} type="submit">Save and continue</button> */}
       <Grid container justifyContent="center" style={{paddingTop:"20px"}}>
            <Button
                variant="contained"
                style={{justifyContentContent: 'center'}}
                type="button"
                color="primary"
                size="large"
                className={classes.button}
                startIcon={<Backup />}
                onClick={()=>{history.push('/inventories')}}
            >
                Go Back
            </Button>
            </Grid>
      </Container>
  </div>
                  
    

  )
}

export default InventoryDetails
